import { render, staticRenderFns } from "./MSTeamsTabConfig.vue?vue&type=template&id=6844e812&scoped=true&"
import script from "./MSTeamsTabConfig.vue?vue&type=script&lang=js&"
export * from "./MSTeamsTabConfig.vue?vue&type=script&lang=js&"
import style0 from "./MSTeamsTabConfig.vue?vue&type=style&index=0&id=6844e812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844e812",
  null
  
)

export default component.exports